import { cx } from '@linaria/core';
import { useRef, useMemo } from 'react';
import { makeIArkStore, iArkStore } from '@apps/i-ark';
import { usePM2DisplayContext } from '@pm2/store';
import { InMemoryNavigationProvider } from '@provider/navigation';
import { isPlatformNodeJS } from '@utils/common';
import { useComponentEntry, ComponentDisplayContext } from '@utils/component-framework';
import { wrapper } from './comp.root.style.js';
import { Router } from './comp.router.js';
import { jsx } from 'react/jsx-runtime';

function PM2IArkComponent(props) {
  const internalRef = useRef(null);
  const rootRef = props.ref ?? internalRef;
  const {
    inLightbox
  } = usePM2DisplayContext();
  const entryKey = props.node.component.entryKey;
  const store = useMemo(() => props.propagatedStore ?? makeIArkStore({
    component: props.node.component,
    entryKey,
    lineColor: "#000",
    lineToolEnabled: false,
    zoom: 1,
    showPrintLayout: false
  }), [entryKey, props.node.component, props.propagatedStore]);
  const entryTaskId = useComponentEntry(entryKey, {
    select: entry => entry?.data.currentTaskId
  });
  const initialPath = useMemo(() => {
    const byUrl = isPlatformNodeJS() ? undefined : new URLSearchParams(window.location.search).get(`i-ark-${props.node.component.envelope.ID}`) ?? undefined;
    if (byUrl) {
      return byUrl;
    }
    if (entryTaskId.data) {
      return entryTaskId.data;
    }
    return "";
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /*#__PURE__*/jsx(iArkStore.Provider, {
    store: store,
    children: /*#__PURE__*/jsx(ComponentDisplayContext.Provider, {
      value: inLightbox ? "lightbox" : "embedded",
      children: /*#__PURE__*/jsx("article", {
        ref: rootRef,
        className: cx(wrapper, inLightbox && "inLightbox"),
        children: /*#__PURE__*/jsx(InMemoryNavigationProvider, {
          basePath: `${isPlatformNodeJS() ? "/" : window.location.pathname}?i-ark-${props.node.component.envelope.ID}=/`,
          initialPath: initialPath,
          children: /*#__PURE__*/jsx(Router, {
            ...props,
            rootRef: rootRef,
            propagatedStore: store
          })
        })
      })
    })
  });
}

export { PM2IArkComponent };
//# sourceMappingURL=comp.root.js.map
